import React from 'react';
import ScrollView from './helpers/scrollView';
import Utils from '../utils/utils';
import Price from './price';

export const BulkyBody = ({ item, currency, reasonError, refundsRequested, setState }) => {

  const _refundableCodes = item.codes.filter((obj) => obj.refundable);

  const _bulkRefundRequest = code => {
    let refundCodes, nextReasonError;
    if (refundsRequested.length === 0) {
      nextReasonError = false;
    }
    if (!!code) {
      refundCodes = refundsRequested;
      if (refundCodes.includes(code)) {
        refundCodes.splice(refundCodes.indexOf(code), 1);
      } else {
        refundCodes.push(code);
      }
    } else {
      if (refundsRequested.length === _refundableCodes.length) {
        refundCodes = []
      } else {
        refundCodes = _refundableCodes.map((code) => code.code);
      }
    }
    setState({refundCodes, reasonError: nextReasonError, refundSuccess: undefined});
  }

  const rows = _refundableCodes.map((code) => {
    let checked = refundsRequested.includes(code.code);
    return (
      <tr key={code.code} className={(checked ? 'checked' : '')} onClick={() => _bulkRefundRequest(code.code)}>
        <td className='checkbox'><input type='checkbox' checked={checked} readOnly={true} /></td>
        <td className='code'>{code.code}</td>
        <td className='price'><Price price={Utils._itemPrice(item, currency)} currency={currency} skipCurrency={true}/></td>
      </tr>
    );
  })

  const headerChecked = _refundableCodes.length === refundsRequested.length;
  return (
      <div className='bulk-refunds-table-container'>
        <strong>{i18n.t('refunds.select-codes')}</strong>
        {reasonError && <div className="failure-message visible">{i18n.t("refunds.bulk.pick-one")}</div>}
        <table className='bulk-refunds'>
          <thead>
            <tr className={(headerChecked ?  'checked' : '')} onClick={() => _bulkRefundRequest() } >
              <th className='checkbox'><input type='checkbox' checked={headerChecked} readOnly={true} /></th>
              <th className='codes'>{i18n.t('refunds.bulk.available-codes')} (<strong>{_refundableCodes.length}</strong>)</th>
              <th className='price'>{i18n.t('transactions.price')}</th>
            </tr>
          </thead>
          <ScrollView element='table-body'>
            {rows}
          </ScrollView>
        </table>
        <div className='code-selections'>
          <span className='codes'>{i18n.t('refunds.bulk.codes-selected')}: <strong>{refundsRequested.length}</strong></span>
          <div className='price-wrapper'>
            <span className='total'>{i18n.t('transactions.total')}: <strong><Price price={parseInt(refundsRequested.length, 10) * Utils._itemPrice(item, currency)} currency={currency} skipCurrency={true}/></strong></span>
          </div>
        </div>
        <div>
        </div>
      </div>
  );
}

export const SlimBody = ({setState, reasonError, reasons}) => {
  const _onCheckboxChange = e => {
    let input = e.target;
    let name = input.getAttribute('name');
    let stateUpdates = {};
    stateUpdates[name] = !reasons[name];
    stateUpdates.reasonError = false;
    stateUpdates.refundSuccess = undefined;
    if (name === 'other' && stateUpdates.other === false) {
      stateUpdates['otherExplain'] = '';
    }
    setState(stateUpdates);
  }

  const _onOtherExplainChange = e => {
    const otherExplain = e.target.value;
    const other = !!otherExplain
    setState({ otherExplain, other, reasonError: false, refundSuccess: undefined });
  }

  const _giveReasons = () => {
    return reasons.other && !reasons["other-explain"];
  }

  const _errorMessage = () => {
    if (reasonError) {
      let localizedString;
      if (_giveReasons()) {
        localizedString = 'refunds.missing-elaboration'
      } else {
        localizedString = 'refunds.missing-reason';
      }
      return <div className="failure-message visible">{i18n.t(localizedString)}</div>
    }
  }

  return (
    <div className="why">
      <strong>{i18n.t('refunds.why')}</strong> <span>{i18n.t('base.required')}*</span>
      { reasonError && _errorMessage()}
      <ul className="reasons">
        <li>
          <input type="checkbox" name="dropped" id="dropped-course" checked={!!reasons.dropped} onChange={(e) => _onCheckboxChange(e)} />
          <label htmlFor="dropped-course">{i18n.t('refunds.reasons.dropped')}</label>
        </li>
        <li>
          <input type="checkbox" name="wrong" id="wrong-book" checked={!!reasons.wrong} onChange={(e) => _onCheckboxChange(e)} />
          <label htmlFor="wrong-book">{i18n.t('refunds.reasons.wrong')}</label>
        </li>
        <li>
          <input type="checkbox" name="print" id="print-version" checked={!!reasons.print} onChange={(e) => _onCheckboxChange(e)} />
          <label htmlFor="print-version">{i18n.t('refunds.reasons.print')}</label>
        </li>
        <li>
          <input type="checkbox" name="missing" id="missing-content" checked={!!reasons.missing} onChange={(e) => _onCheckboxChange(e)} />
          <label htmlFor="missing-content">{i18n.t('refunds.reasons.missing')}</label>
        </li>
        <li>
          <input type="checkbox" name="other" id="other-reason" checked={!!reasons.other} onChange={(e) => _onCheckboxChange(e)} />
          <input className={"medium" + (reasonError && _giveReasons() ? " failure" : "")} type="text" name="other-explain" id="other-explain" value={reasons.otherExplain || ''} onChange={(e) => _onOtherExplainChange(e)} />
        </li>
      </ul>
    </div>
  );
}
